import { StorageUtil } from '@cleartax/wg-library-utils';
import { PropsWithChildren, useEffect, useState } from 'react';
import { UserProvider } from '.';
import { SESSION_STORAGE_KEYS } from '../../../config/constants';
import { TUser } from './user.type';

export const UserContainer: React.FC<PropsWithChildren<TUser>> = ({
  username,
  isLoggenIn,
  role,
  children,
}) => {
  const [user, setUser] = useState<TUser>({
    username,
    isLoggenIn,
    role,
  });

  useEffect(() => {
    StorageUtil.setItem(SESSION_STORAGE_KEYS.USERNAME, user.username);
  }, [user]);

  const logout = () =>
    setUser({
      role: 'CUSTOMER',
      username: '',
      isLoggenIn: false,
    });
  return (
    <UserProvider value={{ ...user, logout: logout }}>{children}</UserProvider>
  );
};
